import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Buttons, FlexContainer, Separator, Text, Spinner } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { showModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { createURL } from 'Containers/Plans/utils';
import { useFetchGetPlans } from 'Containers/Plans/hooks';
import { FRONT_PLANS, parsePlans } from 'Constants/plans';
import { PAYMENT_METHOD_MODAL } from 'Constants/modals';
import { routes } from 'Constants/routes';
import { PlansType } from 'Types/common';
import PaymentMethods from '../PreviousYears/components/PaymentMethods';
import BenefitsList from './components/BenefitsList';
import * as Styled from './styles';
import { preSaleTexts } from './utils';

const PreSalePro = (): JSX.Element => {
  const [planPro, setPlanPro] = useState<PlansType>();
  const { t } = useTranslation(locizeNS.PY);
  const dispatch = useDispatch();
  const { data: plans, isLoading } = useFetchGetPlans();
  const params = { plans: 'Plan Pro' };

  const handleClickPayNow = (): void => {
    dispatch(
      showModalAction({
        options: {
          type: PAYMENT_METHOD_MODAL,
          data: {
            plan: 'Pro',
            successUrl: createURL(routes.PREVIOUS_YEARS_WORKING, params),
            cancelUrl: createURL(routes.PREVIOUS_YEARS),
            upsellingProps: planPro,
          },
        },
      })
    );
  };

  useEffect(() => {
    if (plans) {
      const filterPlanPro = plans?.find(item => parsePlans(item.name) === FRONT_PLANS.PRO);
      setPlanPro(filterPlanPro);
    }
  }, [plans]);

  return (
    <Styled.ThreeColLayout>
      <Styled.TitleContainer type="fds_heading_bold_H4" color="dark_500">
        {t('PreviousYears.title')}
      </Styled.TitleContainer>
      <FlexContainer direction="column">
        <Styled.Title type="fds_heading_bold_H4" color="dark_500">
          {t('PreviousYears.title')}
        </Styled.Title>
        <Styled.Container align="center" justify="center" direction="column">
          {isLoading && !planPro ? (
            <Spinner size="M" align="center" justify="center" />
          ) : (
            <>
              <Styled.Box>
                <Text align="center" type="fds_text_bold_XL" color="dark_500" mb="fds_size_08">
                  {t(preSaleTexts?.title)}
                </Text>
                {preSaleTexts.type !== 'equal' && (
                  <Text type="fds_text_bold_L" color="dark_500">
                    {t(preSaleTexts?.subtitle)}
                  </Text>
                )}
                <Text type="fds_heading_bold_H4" color="dark_500">
                  {YayoyakiFormatter.formatAmountMxn(
                    planPro ? Math.abs(Number(planPro?.price?.amountDecimal)) : 0
                  )}
                </Text>
                <Separator mr="fds_size_16" ml="fds_size_16" mt="fds_size_24" />
                <Text type="paragraphs" color="dark" size="S_S_S" align="center" mt="fds_size_24">
                  {t(preSaleTexts?.disclaimer)}
                </Text>
                <Buttons.Classic
                  mode="primary"
                  size="s"
                  label={t(preSaleTexts?.buttonLabel)}
                  onClick={() => handleClickPayNow()}
                />
                <BenefitsList />
              </Styled.Box>
              <PaymentMethods />
            </>
          )}
        </Styled.Container>
      </FlexContainer>
    </Styled.ThreeColLayout>
  );
};

export default PreSalePro;
